// extracted by mini-css-extract-plugin
export default {"container":"vo-z","brandName":"wo-z","productName":"xo-z","productNamePdpEnhancements":"yo-z","breakLongProductName":"zo-z"};